/** import external dependencies */
import 'jquery';
import 'jquery-form';
import '@fancyapps/fancybox';

/** import local dependencies */
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import acceptCookiesModule from './modules/accept-cookies';
import ingredientModule from './modules/ingredients';
import iofferModule from './modules/ioffer';
import historyModule from './modules/history';
import mapSiteModule from './modules/map-site';
import startupPopinModule from './modules/startup-popin';
import menuModule from './modules/menu';

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
  /** All pages */
  common,
  /** Home page */
  home,
  /** About Us page, note the change from about-us to aboutUs. */
  aboutUs,
});
/** Load Events */
jQuery(document).ready(() => {
  routes.loadEvents();
  acceptCookiesModule();
  historyModule();
  ingredientModule();
  iofferModule();
  mapSiteModule();
  menuModule();
  startupPopinModule();
});



// WEBPACK FOOTER //
// ./scripts/main.js